import { render } from "./quiz-trigger.vue?vue&type=template&id=5bc8372c&ts=true"
import script from "./quiz-trigger.vue?vue&type=script&lang=ts"
export * from "./quiz-trigger.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__